import { Controller } from "@hotwired/stimulus"

// Row-level handlers:
// - openSidePanel: click on row body fetches the task's panel partial
//   and triggers the side-panel controller to show.
// - stopPropagation: any inner cell that the user clicks should NOT
//   bubble up to the row body.
// - toggleStatusExpansion: shows/hides per-assignee status rows for
//   multi-assignee tasks.
export default class extends Controller {
  static targets = ["statusExpansion"]

  openSidePanel(event) {
    const taskId = this.element.dataset.taskId
    if (!taskId) return

    // Native Turbo Frame: set src and Turbo fetches, extracts the
    // matching <turbo-frame id="side_panel_content"> from the response,
    // and swaps the contents. No manual fetch needed.
    const frame = document.getElementById("side_panel_content")
    // The panel's Duplicate button sends the copy back to the same filtered
    // view, so the current intern-card selection rides along.
    // So do the lists opened with Show older (?older=, 2026-10-14).
    const page = new URLSearchParams(window.location.search)
    const keep = new URLSearchParams()
    for (const key of ["interns", "older"]) if (page.get(key)) keep.set(key, page.get(key))
    const query = keep.toString() ? `?${keep}` : ""
    if (frame) frame.src = `/admin/intern_tasks/${taskId}/panel${query}`

    const panelEl = document.querySelector("[data-controller~='side-panel']")
    panelEl?.dispatchEvent(new CustomEvent("side-panel:open", { bubbles: true }))
  }

  stopPropagation(event) {
    event.stopPropagation()
  }

  toggleStatusExpansion(event) {
    event.stopPropagation()
    if (!this.hasStatusExpansionTarget) return
    this.statusExpansionTarget.hidden = !this.statusExpansionTarget.hidden
  }
}
